import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// A página /admin redireciona para o login unificado /entrar
export default function AdminLogin() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/entrar", { replace: true });
  }, [navigate]);
  return null;
}
